<template>
  <div class="faq-container">
    <br/>
    <h1>常見問題</h1>
    <h4>
      請先參考
      <a href="https://docs.google.com/document/d/14j0lEEZH5A1FNum7L6p9U1ETWx_0JTyasahIi9DLe3w/edit?usp=sharing" target="_blank">給家長的教學引導</a>
    </h4>
    <div class="ui grid container">
      <div class="ui stackable two column row">
        <div class="ui segment column">
          <h2>教材架構</h2>
          <h4>Q: 學數學應該每日練習嗎？</h4>
          <p>除了學習有興趣的領域；建議像運動一樣，養成每日10分鐘寫題目的習慣，對於複習和活化腦部都有幫助。</p>
          <h4>Q: 自由數學的攀岩地圖和學校課綱的結構一樣嗎？如何對照？</h4>
          <p>不同。自由數學的攀岩地圖不只是依年紀分，還有「知識叢集」的概念，如分數與小數叢集，包含完整的分數與小數概念、計算方式，跨越課本近三個年級的範圍。</p>
          <p>經驗上，學習者如果把目標放在學完整個叢集，再切換到別處，有助於知識的深化與固化。</p>
          <p>如果自學家庭有要返校考試的壓力，也可以兩線同步進行：一個照著「知識叢集」一塊一塊的學習，一是照著課本螺線式的學習，可以相輔相成。</p>
          <h4>Q: 自由數學知識地圖與單元教材能不能分開使用？</h4>
          <p>當然可以。</p>
          <p>地圖主要是計劃和記錄的工具，可以搭配各種教材，除了自由數學，像課本、Khan Aacdemy、均一等都可以搭配。</p>
          <p>自由數學單元教材，不只可以對應到攀岩地圖，也可以對應到別種脈絡，如學校課綱、Khan Knowledge Map、均一知識星空等。均為相容。</p>
          <p>事實上，組識學習進程的方法，不只一種；各單元的教材教法也不只一種。除了選擇搭配，您還可以自創，例如用您喜歡的方式自己畫出獨特的知識地圖。</p>
          <h4>Q: 自由數學單元教材和課本單元結構一樣嗎？如何對照？</h4>
          <p>範圍大至相同，但是編輯處理的方式不一樣。</p>
          <p>目前課綱是螺旋式的，有些單元分散在好幾個年紀，一次教一些，學生學了一部分就要跳到別的單元去。</p>
          <p>自由數學的教材有「知識叢集」的概念，比較集中，像「分數」單元就會從頭講起，從由來、表徵方式、等價分數、同分母與異分母的加減、一直到分數乘除以及分子分母含0的特殊情況，才完整告一段落。</p>
          <p>如果要和課本對照，可以採取兩線進度的方式，課本與自由數學教材，範圍有很大的交集，只是介紹的方式不同，可以並用參照。</p>
          <h4>Q: 地圖上的單元都有搭配的「自由數學」自學教材嗎?</h4>
          <p>我們的方針是重質勝於重量。</p>
          <p>人力有限時，我們把3~9年級範圍做的比較好，品質優良，且大部份的單元都有。但也並不是每有單元都有。如果您遇到地圖上有單元沒有對應的教材，可用單元名當關鍵字，上網查詢各方教材、教學短片。</p>
          <p>3年級以下，建議多搭配具體的操作與遊戲，紙筆操作和電腦的操作都不宜太多。</p>
          <p>9年級以上，中英文的閱讀力較強，一般課本與各方網路教材足勘使用。此時也可嘗試英文網站，如:</p>
          <p><a href="https://www.khanacademy.org/" target="_blank">https://www.khanacademy.org/</a></p>
          <p><a href="http://www.w3schools.com/" target="_blank">http://www.w3schools.com/</a>等等。</p>
        </div>
        <div class="ui segment column">
          <h2>自學過程</h2>
          <h4>Q: 教材中有些空格是需要學生自行填寫的，如果不知道該填入什麼或是不確定填入的答案是否正確時該怎麼辦呢？</h4>
          <p>A: 如果遇到不知如何填寫，可以直接在文件上留言提問，也可上Github
            <a class="item" href="https://github.com/bestian/freemath/milestone/5" target="_blank" rel="noopener norefferer">
              <i class="github icon"></i>自由數學議題區
            </a>提問，可將卡住的部份拍照上傳，並寫一些目前的想法與疑問，就會有人回答了。</p>
          <p></p>
          <h4>Q: 觀念性空格的答案何不附在最後面？</h4>
          <p>A: 謝謝您的建議。不過，有時空格並無標準答案，也有時雖有標準答案，但在課堂上較常鼓勵學生勇敢去猜，猜錯也沒有關係，只要後面能繼續往下，如果前面的觀念一時有誤，也能再更正。</p>
          <p>所以沒有留下空格的標準答案，如同習題也沒有留下標準答案。</p>
          <p>如果在教學時發現有標準答案的版本較符合需求，可以在google docs中複製出您自己的版本來改。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.faq-container {
  padding: 20px;
  max-width: 1200px;
  margin: auto;
  font-family: 'Roboto', sans-serif;
  color: #333;
}

.faq-container h1 {
  font-size: 2.5em;
  font-weight: bold;
  color: #0056b3;
  text-align: center;
  margin-bottom: 20px;
}

.faq-container h2 {
  font-size: 1.75em;
  color: #004085;
  border-bottom: 2px solid #0056b3;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.faq-container h4 {
  font-size: 1.25em;
  color: #333;
  margin-bottom: 10px;
}

.faq-container p {
  font-size: 1em;
  line-height: 1.6;
  margin-bottom: 15px;
}

.faq-container a {
  color: #0056b3;
  text-decoration: none;
}

.faq-container a:hover {
  text-decoration: underline;
}

.ui.grid.container {
  margin-top: 20px;
}

.ui.stackable.two.column.row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.ui.segment.column {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
  flex: 1;
  margin-right: 10px;
  min-width: 100%;
}

.ui.segment.column:last-child {
  margin-right: 0;
}

.ui.segment.column h4 {
  font-size: 1.25em;
  margin-top: 20px;
}

.ui.segment.column p {
  font-size: 1em;
  color: #495057;
}

@media (min-width: 600px) {
  .ui.segment.column {
    min-width: calc(50% - 20px);
  }
}
</style>
